import React from 'react';
import PropTypes from 'prop-types';
import { CookieCompliance, CookieComplianceCategories } from '@deporvillage/utils-library-component';

const PixelCampaign = ({ category }) => {
    const elem = React.useRef(false);
    const [isInit, setInit] = React.useState(false);
    const handleInit = (canRun) => setInit(canRun);

    React.useEffect(() => {
        CookieCompliance(handleInit, CookieComplianceCategories.Targeting);
    }, []);

    React.useEffect(() => {
        if (isInit) {
            const axel = `${Math.random()}`;
            const a = axel * 10000000000000;
            const iframe = document.createElement('iframe');
            const mySrc = `https://11514954.fls.doubleclick.net/activityi;src=11514954;type=deporv;cat=${category};dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=\${GDPR};gdpr_consent=\${GDPR_CONSENT_755};ord=1;num=${a}?`;
            iframe.style.display = 'none';
            iframe.width = '1';
            iframe.height = '1';
            iframe.frameborder = '0';
            iframe.src = mySrc;
            iframe.setAttribute('fetchpriority','low');
            elem.current.appendChild(iframe);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isInit]);

    return isInit && <div ref={elem} />;
};

PixelCampaign.propTypes = {
    category: PropTypes.string,
};

export default PixelCampaign;
